module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Option-e62ee18ab7863255eb735ef73b73aa52.svg";